export default __webpack_public_path__ + "static/media/shanghai.1de6c40d.png";